import pythonApiClient from './pythonBaseApi';

// Usar cliente base compartido de Python API
const basePath = '/mantenimientos/habitaciones';

export const habitacionApi = {
  // Obtener todas las habitaciones
  getHabitaciones: async (moduloId = null, estadoHabitacionId = null) => {
    const params = {};
    if (moduloId) params.modulo_id = moduloId;
    if (estadoHabitacionId) params.estado_habitacion_id = estadoHabitacionId;
    return pythonApiClient.get(`${basePath}/`, { params });
  },

  // Obtener habitaciones con estadísticas
  getHabitacionesWithStats: async (moduloId = null, estadoHabitacionId = null, piso = null) => {
    const params = {};
    if (moduloId) params.modulo_id = moduloId;
    if (estadoHabitacionId) params.estado_habitacion_id = estadoHabitacionId;
    if (piso) params.piso = piso;
    return pythonApiClient.get(`${basePath}/stats`, { params });
  },

  // Obtener habitación por ID
  getHabitacionById: async (habitacionId) => {
    return pythonApiClient.get(`${basePath}/${habitacionId}`);
  },

  // Obtener habitación con relaciones
  getHabitacionWithRelations: async (habitacionId) => {
    return pythonApiClient.get(`${basePath}/${habitacionId}/relations`);
  },

  // Obtener estadísticas de una habitación
  getHabitacionStatistics: async (habitacionId) => {
    return pythonApiClient.get(`${basePath}/${habitacionId}/statistics`);
  },

  // Crear habitación
  createHabitacion: async (habitacionData) => {
    return pythonApiClient.post(`${basePath}/`, habitacionData);
  },

  // Actualizar habitación
  updateHabitacion: async (habitacionId, habitacionData) => {
    return pythonApiClient.put(`${basePath}/${habitacionId}`, habitacionData);
  },

  // Eliminar habitación
  deleteHabitacion: async (habitacionId) => {
    return pythonApiClient.delete(`${basePath}/${habitacionId}`);
  },

  // Obtener habitaciones por módulo
  getHabitacionesByModulo: async (moduloId) => {
    return pythonApiClient.get(`${basePath}/modulo/${moduloId}`);
  },

  // Buscar habitaciones
  searchHabitaciones: async (searchTerm, moduloId = null) => {
    const params = { q: searchTerm };
    if (moduloId) params.modulo_id = moduloId;
    return pythonApiClient.get(`${basePath}/search`, { params });
  },
};

export default habitacionApi;